/* ==========================================================================
   GutNourish theme — product-form.js
   Subscription-aware buy box.

   Reads a JSON payload rendered by sections/main-product.liquid describing every
   variant and its selling-plan allocations. Works with ANY Shopify subscription
   app (Loop, Recharge, etc.) because they all publish native SellingPlanGroups.

   If no selling plans exist yet — e.g. before the subscription app is installed —
   the purchase-type control hides itself and this degrades to a plain variant
   picker. The page is never broken by a missing app.
   ========================================================================== */
(function () {
  'use strict';

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var esc = function (v) {
    return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* Subscription apps name their plans however they like — Loop tends to emit
     things like "Delivery every 1 month". We print the name inside a sentence
     ("$164.95 billed every 3 months"), so normalise it rather than trusting it. */
  function cadencePhrase(name) {
    if (!name) return '';
    var s = String(name).toLowerCase().trim();
    s = s.replace(/^(delivery|deliver|subscription|subscribe|ships?)\s+/, '');
    s = s.replace(/^(once\s+)?every\s+1\s+/, 'every ');
    s = s.replace(/\s+/g, ' ').trim();
    if (s && !/^every\b/.test(s) && /^\d/.test(s)) s = 'every ' + s;
    return s;
  }

  function initProductForm(root) {
    $$('[data-product-form]', root === document ? document : root.parentNode || document).forEach(setup);
    if (root !== document && root.matches && root.matches('[data-product-form]')) setup(root);
  }

  function setup(form) {
    if (form.dataset.wired === 'true') return;
    form.dataset.wired = 'true';

    var dataEl = $('[data-product-json]', form);
    if (!dataEl) return;

    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var variants = data.variants || [];
    if (!variants.length) return;

    var hasPlans = variants.some(function (v) { return (v.sellingPlans || []).length; });

    var state = {
      variantId: data.initialVariantId || variants[0].id,
      mode: hasPlans && data.defaultSubscribe ? 'subscribe' : 'onetime',
      planId: null
    };

    var els = {
      seg: $('[data-purchase-type]', form),
      segSave: $('[data-seg-save]', form),
      segBtns: $$('[data-mode]', form),
      perks: $$('[data-perk-scope]', form),
      rows: $$('[data-variant-row]', form),
      freqWrap: $('[data-frequency]', form),
      freqSelect: $('[data-frequency-select]', form),
      unit: $('[data-price-unit]', form),
      unitLabel: $('[data-price-unit-label]', form),
      compare: $('[data-price-compare]', form),
      cadence: $('[data-price-cadence]', form),
      save: $('[data-price-save]', form),
      saveBasis: $('[data-price-basis]', form),
      perServe: $('[data-price-serve]', form),
      submit: $('[data-atc]', form),
      note: $('[data-atc-note]', form),
      idInput: $('[name="id"]', form),
      planInput: $('[name="selling_plan"]', form),
      stickyWhat: $('[data-sticky-what]'),
      stickyPrice: $('[data-sticky-price]'),
      stickyProxy: $('[data-sticky-bar] [data-atc-proxy]'),
      dynamicCheckout: $('[data-dynamic-checkout]', form)
    };

    if (els.seg) els.seg.hidden = !hasPlans;

    /* The one-time price of a single tub: what a card's "Save $X" line is measured against
       (Owen, 25 Sep: "Savings are against the one-time price of $89.95 a tub"). */
    var singleTubPrice = (function () {
      var one = variants.filter(function (v) { return (v.tubs || 1) === 1; })[0];
      return one ? one.price : 0;
    })();

    function variant(id) {
      for (var i = 0; i < variants.length; i++) if (variants[i].id === id) return variants[i];
      return variants[0];
    }

    function plansFor(v) { return v.sellingPlans || []; }

    /* Subscription apps list frequencies in whatever order they were created, so
       "first plan" is not a sensible default — it currently means every 2 weeks on
       a one-month tub. Default instead to the cadence that matches how long the
       pack actually lasts: 1 tub (1 month supply) -> monthly, 3 tubs -> quarterly.
       Derived from the data, so it stays right if frequencies are added later. */
    function cadenceDays(name) {
      var m = String(name || '').toLowerCase().match(/(\d+)?\s*(day|week|month|year)/);
      if (!m) return null;
      var n = parseInt(m[1] || '1', 10);
      var unit = m[2];
      return n * (unit === 'day' ? 1 : unit === 'week' ? 7 : unit === 'month' ? 30 : 365);
    }

    function defaultPlanId(v) {
      var plans = plansFor(v);
      if (!plans.length) return null;
      var wantDays = (v.tubs || 1) * 30;
      var best = plans[0], bestDelta = Infinity;
      plans.forEach(function (p) {
        var c = cadenceDays(p.name);
        if (c === null) return;
        var d = Math.abs(c - wantDays);
        if (d < bestDelta) { bestDelta = d; best = p; }
      });
      return best.id;
    }


    function currentOffer() {
      var v = variant(state.variantId);
      if (state.mode === 'subscribe') {
        var plans = plansFor(v);
        var defId = defaultPlanId(v);
        var plan = plans.filter(function (p) { return p.id === state.planId; })[0]
                || plans.filter(function (p) { return p.id === defId; })[0] || plans[0];
        if (plan) {
          return {
            price: plan.price,
            compareAt: plan.compareAtPrice || v.compareAtPrice,
            cadence: plan.name,
            plan: plan,
            subscribing: true,
            variant: v
          };
        }
      }
      return { price: v.price, compareAt: v.compareAtPrice, cadence: null, plan: null, subscribing: false, variant: v };
    }

    function money(cents) { return window.formatMoney ? window.formatMoney(cents) : '$' + (cents / 100).toFixed(2); }

    /* The plan a row should quote. The selected row follows the frequency the shopper
       picked; the others show the default cadence for their size. Every size currently
       prices all of its frequencies the same, but this keeps the card, the price box and
       the sticky bar in agreement if that ever changes. */
    function rowPlan(v, isSelected) {
      var plans = plansFor(v);
      if (!plans.length) return null;
      if (isSelected && state.planId) {
        var chosen = plans.filter(function (p) { return p.id === state.planId; })[0];
        if (chosen) return chosen;
      }
      var defId = defaultPlanId(v);
      return plans.filter(function (p) { return p.id === defId; })[0] || plans[0];
    }

    /* Rounded percentage saving of a price against RRP x tubs (0 when there is none). */
    function savePct(v, price) {
      var base = rrpBase(v);
      if (!base || price >= base) return 0;
      return Math.round((1 - price / base) * 100);
    }

    function fill(template, map) {
      return String(template || '').replace(/\{(\w+)\}/g, function (m, key) {
        return Object.prototype.hasOwnProperty.call(map, key) ? map[key] : m;
      });
    }

    /* What a subscription saving is measured AGAINST.
       It used to be the one-time price of the same size, which quoted the 3-tub
       subscription at "Save 10%" — true against the bundle, but the bundle is
       already discounted, so it badly undersold the offer. Against RRP the same
       subscription is 33% (3 x $89.95 = $269.85 vs $179.95) and the single tub is
       22% ($89.95 vs $69.95). Owen asked for the RRP basis on 2026-08-20.
       Falls back to the one-time price if no RRP is set, so clearing the
       rrp_per_tub metafield degrades to the old behaviour instead of showing 0%. */
    function rrpBase(v) {
      var rrp = v.rrpPerTub || 0;
      if (!rrp) return v.price;
      return rrp * (v.tubs || 1);
    }

    function paintRows() {
      els.rows.forEach(function (row) {
        var id = parseInt(row.getAttribute('data-variant-row'), 10);
        var v = variant(id);
        var subscribable = state.mode !== 'subscribe' || plansFor(v).length > 0;
        var usable = v.available && subscribable;

        // A size with no subscription plan is hidden outright while Subscribe is
        // active, rather than shown greyed out — no dead option in the list.
        /* A size is hidden when it cannot be bought the way the shopper is currently
           buying: no plan while subscribing, or subscription-only while buying once.
           The 3 and 6 tub variants stay published either way — the subscriptions and the
           existing subscribers hang off them. */
        row.hidden = (state.mode === 'subscribe' && plansFor(v).length === 0)
                  || (state.mode !== 'subscribe' && v.subscriptionOnly === true);

        row.classList.toggle('supply__row--off', !usable && !row.hidden);
        row.classList.toggle('supply__row--on', usable && id === state.variantId);

        var input = $('input', row);
        if (input) { input.disabled = !usable; input.checked = usable && id === state.variantId; }

        var offer = null;
        if (state.mode === 'subscribe' && plansFor(v).length) {
          var p = rowPlan(v, id === state.variantId);
          offer = { price: p.price, per: true };
        } else {
          offer = { price: v.price, per: false };
        }

        /* Saving chip (brief 2026-09-22, A): shown on every subscription card, collapsed
           or not, so the sizes can be compared without opening each one. */
        var saveChip = $('[data-row-save]', row);
        if (saveChip) {
          var pct = offer.per ? savePct(v, offer.price) : 0;
          saveChip.hidden = pct <= 0;
          saveChip.textContent = (data.strings.saveShort || 'Save') + ' ' + pct + '%';
        }

        var unitEl = $('[data-row-unit]', row);
        var totalEl = $('[data-row-total]', row);
        var rowPerTub = v.tubs ? Math.round(offer.price / v.tubs) : offer.price;
        if (unitEl) unitEl.textContent = money(rowPerTub);

        /* The RRP is only a saving if the row is actually below it. On the one-time
           single tub the per-tub price IS the RRP ($89.95), so a fixed strikethrough
           struck the price through against itself — Owen flagged it 2026-08-26.
           Hide it whenever there is nothing to compare against. */
        var rrpEl = $('[data-row-rrp]', row);
        if (rrpEl) rrpEl.hidden = !v.rrpPerTub || v.rrpPerTub <= rowPerTub;
        if (totalEl) {
          /* The total used to render as a bare number with nothing saying what it was.
             Label it on both toggles: a one-off is the order total, a subscription is
             what they pay each delivery. */
          var totalLabel = row.getAttribute('data-total-label') || 'Total:';
          var deliveryLabel = row.getAttribute('data-delivery-label') || 'Per delivery:';
          totalEl.textContent = (offer.per ? deliveryLabel : totalLabel) + ' ' + money(offer.price);
        }

        /* Round 1 (Owen, 25 Sep): every card gives its price per serve, as a smaller line under the
           per-tub price, and the multi-tub cards the dollars saved against buying that many single
           tubs at the one-time price. Both follow the card's own live price. */
        var serveEl = $('[data-row-serve]', row);
        if (serveEl) {
          var rowServes = (v.tubs || 1) * (parseInt(data.servesPerTub, 10) || 0);
          serveEl.hidden = !(rowServes > 0);
          serveEl.textContent = rowServes > 0
            ? fill(data.strings.rowServe || '{price} per serve', { price: money(Math.round(offer.price / rowServes)) })
            : '';
        }
        var savedEl = $('[data-row-saved]', row);
        if (savedEl) {
          var rowTubs = v.tubs || 1;
          var saved = (rowTubs > 1 && singleTubPrice > 0) ? singleTubPrice * rowTubs - offer.price : 0;
          savedEl.hidden = !(saved > 0);
          savedEl.textContent = saved > 0 ? fill(data.strings.rowSaved || 'Save {amount}', { amount: money(saved) }) : '';
        }

        /* Success System state for this row. It comes with 3 tubs, 6 tubs, or ANY
           size bought on subscription — so a 1-tub row qualifies the moment the
           shopper switches to Subscribe, and stops qualifying if they switch back.
           Two states rather than one: the selected row opens the full list, other
           qualifying rows keep a single line so the bonus is still visible while
           they are comparing, which was the actual complaint. */
        var incl = $('[data-supply-incl]', row);
        if (incl) {
          /* Permanent rules (2026-08-26): ALL subscriptions get the full Success System and
             no one-time purchase does. The old "3 tubs, 6 tubs or subscribe" tiering is gone —
             with the bundles no longer sold one-time there is nothing left to tier. */
          var qualifies = state.mode === 'subscribe';
          var showIncl = qualifies && usable && !row.hidden;
          incl.classList.toggle('is-on', showIncl);
          incl.classList.toggle('is-full', showIncl && id === state.variantId);
          incl.setAttribute('aria-hidden', String(!showIncl));
        }

        var metaEl = $('[data-row-meta]', row);
        if (metaEl && metaEl.getAttribute('data-default-meta')) {
          metaEl.textContent = (state.mode === 'subscribe' && !plansFor(v).length)
            ? (metaEl.getAttribute('data-unavailable-meta') || 'Not available on subscription')
            : metaEl.getAttribute('data-default-meta');
        }
      });
    }

    function paintFrequency() {
      if (!els.freqWrap || !els.freqSelect) return;
      var v = variant(state.variantId);
      var plans = plansFor(v);
      var show = state.mode === 'subscribe' && plans.length > 0;
      els.freqWrap.hidden = !show;
      if (!show) return;

      if (!plans.some(function (p) { return p.id === state.planId; })) state.planId = defaultPlanId(v);

      els.freqSelect.innerHTML = plans.map(function (p) {
        return '<option value="' + p.id + '"' + (p.id === state.planId ? ' selected' : '') + '>' + p.name + '</option>';
      }).join('');
      els.freqSelect.disabled = plans.length < 2;
    }

    function paintPrice() {
      var o = currentOffer();
      var v = o.variant;
      var perTub = v.tubs ? Math.round(o.price / v.tubs) : o.price;

      if (els.unit) els.unit.textContent = money(perTub);
      if (els.unitLabel) els.unitLabel.hidden = !v.tubs;
      if (els.compare) {
        var rrp = v.rrpPerTub || o.compareAt;
        els.compare.textContent = rrp ? money(rrp) : '';
        els.compare.hidden = !rrp || rrp <= perTub;
      }
      if (els.cadence) {
        /* Total per delivery and frequency as two distinct phrases, the frequency always the
           one selected, e.g. "$199.95 per delivery · billed every 10 weeks". */
        els.cadence.innerHTML = o.subscribing
          ? '<b>' + money(o.price) + '</b> ' + (data.strings.perDelivery || 'per delivery') +
            '<span class="pricebox__sep" aria-hidden="true"> · </span><span class="visually-hidden">, </span>' +
            '<span class="pricebox__freq">' + (data.strings.billed || 'billed') + ' ' + cadencePhrase(o.cadence) + '</span>'
          : '<b>' + money(o.price) + '</b> ' + (data.strings.oneTime || 'one-time purchase');
      }
      if (els.save) {
        var saving = 0;
        if (o.subscribing) saving = rrpBase(v) - o.price;         // vs RRP, not the bundle price
        else if (v.compareAtPrice) saving = v.compareAtPrice - v.price;
        els.save.hidden = saving <= 0;
        if (data.saveFormat === 'percent') {
          /* Owen, 25 Sep: percentage savings rather than dollar amounts. The same figure as the card's
             chip and the Subscribe flag (savePct: against RRP x tubs, i.e. single tubs at $89.95); a
             one-off against its compare-at price. The basis line below still says what it is against. */
          var pctOff = o.subscribing ? savePct(v, o.price)
                     : (v.compareAtPrice > v.price ? Math.round((1 - v.price / v.compareAtPrice) * 100) : 0);
          els.save.hidden = !(pctOff > 0);
          els.save.textContent = (data.strings.saveShort || 'Save') + ' ' + pctOff + '%';
        } else {
          els.save.textContent = (data.strings.save || 'Save') + ' ' + money(saving) + (o.subscribing ? ' ' + (data.strings.perDelivery || 'per delivery') : '');
        }

        /* What the saving is measured against: RRP x tubs, i.e. single tubs at $89.95. */
        if (els.saveBasis) {
          var tubsN = v.tubs || 1;
          var showBasis = data.showSaveBasis && o.subscribing && saving > 0 && v.rrpPerTub > 0;
          els.saveBasis.hidden = !showBasis;
          els.saveBasis.textContent = showBasis
            ? fill(tubsN > 1 ? data.strings.saveBasisMany : data.strings.saveBasisOne, { count: tubsN, price: money(v.rrpPerTub) })
            : '';
        }
      }

      /* Optional per-serve price (brief K). Secondary to the full delivery charge. */
      if (els.perServe) {
        var serves = (v.tubs || 1) * (parseInt(data.servesPerTub, 10) || 0);
        var showServe = data.showPerServe && serves > 0;
        els.perServe.hidden = !showServe;
        els.perServe.textContent = showServe ? fill(data.strings.perServe, { price: money(Math.round(o.price / serves)) }) : '';
      }

      /* Every way to pay has to follow the selected variant, not just the main button.
         On a sold-out product the only offer should be the waitlist: the dynamic checkout
         button is hidden outright (Shopify does not reliably hide it), and the sticky bar
         proxy is disabled because it dispatches a submit event that would otherwise sail
         straight past the main button's disabled state. */
      if (els.dynamicCheckout) els.dynamicCheckout.hidden = !v.available;
      if (els.stickyProxy) {
        els.stickyProxy.disabled = !v.available;
        els.stickyProxy.textContent = v.available
          ? (data.strings.addToCart || 'Add to cart')
          : (data.strings.soldOut || 'Sold out');
      }

      if (els.submit) {
        els.submit.disabled = !v.available;
        els.submit.textContent = v.available
          ? (data.strings.addToCart || 'Add to cart') + ' — ' + money(o.price)
          : (data.strings.soldOut || 'Sold out');
      }
      if (els.note) {
        els.note.textContent = o.subscribing
          ? (data.strings.noteSubscribe || '')
          : (v.freeShipping ? (data.strings.noteFree || '') : (data.strings.noteShipping || ''));
      }

      if (els.idInput) els.idInput.value = v.id;
      if (els.planInput) { els.planInput.value = o.plan ? o.plan.id : ''; els.planInput.disabled = !o.plan; }

      // The product name keeps its ™ markup here (Owen, 24 Sep); the variant title is escaped.
      /* Round 1 (stickyOptionLine): the name alone on the first line, then the selected option and
         its price on the second, e.g. "3 tubs · $199.95 every 3 months" (Owen, 25 Sep). */
      var stickyTitle = data.productTitleHtml || esc(data.productTitle);
      var stickyCost = money(o.price) + (o.subscribing ? ' ' + cadencePhrase(o.cadence) : '');
      if (els.stickyWhat) {
        els.stickyWhat.innerHTML = data.stickyOptionLine ? stickyTitle : stickyTitle + ' · ' + esc(v.title);
      }
      if (els.stickyPrice) {
        els.stickyPrice.textContent = data.stickyOptionLine ? v.title + ' · ' + stickyCost : stickyCost;
      }

      form.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant: v, offer: o } }));
    }

    function paintMode() {
      els.segBtns.forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.getAttribute('data-mode') === state.mode));
      });

      /* The reassurance lines under Add to cart differ per purchase type: a
         subscriber cares about the locked price and skipping a delivery, a one-off
         buyer cares about the shipping threshold. Unscoped lines have no attribute
         and are left alone. */
      /* 'subscription-single' (brief 2026-09-22, section 6): the guarantee covers first-time
         single-tub purchases only, so its line shows while a single tub is selected and is never
         presented under the 3 or 6 tub subscription. */
      var selTubs = variant(state.variantId).tubs || 1;
      els.perks.forEach(function (li) {
        var scope = li.getAttribute('data-perk-scope');
        if (scope === 'subscription') li.hidden = state.mode !== 'subscribe';
        else if (scope === 'onetime')  li.hidden = state.mode === 'subscribe';
        else if (scope === 'subscription-single') li.hidden = state.mode !== 'subscribe' || selTubs !== 1;
      });
      /* The compact icon row collapses when every item in it is hidden (one-time purchase). */
      $$('.perkrow', form).forEach(function (rowEl) {
        rowEl.hidden = !$$('li', rowEl).some(function (li) { return !li.hidden; });
      });

      /* Put the actual saving on the Subscribe control itself. It's the reason to
         press it, and it changes per size — reading it off the live plan keeps it
         honest if Loop's pricing ever moves. */
      if (els.segSave) {
        var v = variant(state.variantId);
        var plans = plansFor(v);
        var pct = 0;
        if (plans.length && rrpBase(v) > 0) {
          /* Quote the saving on the plan the shopper will actually get, not the
             cheapest one in the group. Advertising the best price in the list
             over-promises whenever a longer cadence carries a bigger discount. */
          var shown = plans.filter(function (p) { return p.id === state.planId; })[0]
                   || plans.filter(function (p) { return p.id === defaultPlanId(v); })[0]
                   || plans[0];
          pct = Math.round((1 - shown.price / rrpBase(v)) * 100);
        }
        els.segSave.hidden = pct <= 0;
        els.segSave.textContent = (data.strings.saveShort || 'Save') + ' ' + pct + '%';
      }
    }

    function render() { paintMode(); paintRows(); paintFrequency(); paintPrice(); }

    els.segBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.mode = btn.getAttribute('data-mode');
        // If the current size has no plan, fall back to one that does — preferring
        // the configured default size over simply the first (cheapest) one.
        /* mirror of the rule below: leaving Subscribe on a subscription-only size would
           select a row that is now hidden, so move to one that can be bought once. */
        if (state.mode !== 'subscribe' && variant(state.variantId).subscriptionOnly === true) {
          var oneTimeable = variants.filter(function (v) { return v.subscriptionOnly !== true && v.available; });
          if (oneTimeable.length) state.variantId = oneTimeable[0].id;
        }
        if (state.mode === 'subscribe' && !plansFor(variant(state.variantId)).length) {
          var subscribable = variants.filter(function (v) { return plansFor(v).length && v.available; });
          var preferred = subscribable.filter(function (v) { return v.id === data.initialVariantId; })[0];
          var fallback = preferred || subscribable[0];
          if (fallback) state.variantId = fallback.id;
        }
        render();
      });
    });

    els.rows.forEach(function (row) {
      row.addEventListener('click', function (e) {
        var id = parseInt(row.getAttribute('data-variant-row'), 10);
        var v = variant(id);
        if (!v.available || (state.mode === 'subscribe' && !plansFor(v).length)) { e.preventDefault(); return; }
        state.variantId = id;
        render();
      });
    });

    if (els.freqSelect) {
      els.freqSelect.addEventListener('change', function () {
        state.planId = parseInt(els.freqSelect.value, 10);
        /* the saving chip is derived from the chosen plan, so it has to repaint
           with the price — not just the price line. The selected card quotes the
           chosen plan too, so it repaints as well. */
        paintMode();
        paintRows();
        paintPrice();
      });
    }

    form.addEventListener('submit', function (e) {
      if (!window.addToCart) return;               // no JS cart: let the form post normally
      e.preventDefault();
      var o = currentOffer();
      /* Last line of defence. The submit event can be dispatched by things other than the
         main button (the sticky proxy does exactly that), so availability is checked here
         too rather than trusting any one control's disabled state. */
      if (!o.variant.available) return;
      var payload = { items: [{ id: o.variant.id, quantity: 1 }] };
      if (o.plan) payload.items[0].selling_plan = o.plan.id;
      els.submit.disabled = true;
      var label = els.submit.textContent;
      window.addToCart(payload, els.submit)
        .then(function () { els.submit.textContent = data.strings.added || 'Added'; })
        .catch(function () {})
        .then(function () {
          setTimeout(function () { els.submit.disabled = false; paintPrice(); }, 1200);
        });
    });

    /* Back to the supply options without reloading, so the selected size, purchase type and
       frequency stay exactly as they were, then keyboard focus on the selected option. Same
       behaviour as the FAQ's button. */
    function scrollToSupply(dest) {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var header = document.querySelector('.header, [data-header], header');
      var offset = header ? Math.min(header.getBoundingClientRect().height, 120) + 12 : 16;
      var y = dest.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: Math.max(0, y), behavior: reduce ? 'auto' : 'smooth' });
      var focusEl = dest.querySelector('input[name="supply-option"]:checked') || dest;
      if (focusEl === dest && !dest.hasAttribute('tabindex')) dest.setAttribute('tabindex', '-1');
      try { focusEl.focus({ preventScroll: true }); } catch (err) { focusEl.focus(); }
    }

    $$('[data-sticky-bar] [data-atc-proxy]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        /* Round 1 (Owen, 25 Sep): "The button scrolls back to the selector rather than adding to
           cart directly, so the subscription agreement notice is still seen." */
        var bar = btn.closest('[data-sticky-bar]');
        var target = bar ? bar.getAttribute('data-sticky-scroll') : '';
        var dest = target && target.charAt(0) === '#' ? document.getElementById(target.slice(1)) : null;
        if (dest) { scrollToSupply(dest); return; }
        form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      });
    });

    render();
  }

  window.initProductForm = initProductForm;
  if (document.readyState !== 'loading') initProductForm(document);
  else document.addEventListener('DOMContentLoaded', function () { initProductForm(document); });
})();
